export const TEXTS = {
    alfabank: {
        summary: [
            {
                title: '35&nbsp;<span>лет</span>',
                description: 'работаем для вас',
            },
            {
                title: '27&nbsp;000',
                description: 'населенных пунктов с доставкойй',
            },
            {
                title: '38,7&nbsp;<span>млн</span>',
                description: 'клиентов-физлиц',
            },
            {
                title: '700',
                description: 'офисов',
            },
        ],
    },
    askona: {
        summary: [
            {
                title: '39,3&nbsp;<span>млн</span>',
                description: 'посетителей сайта в 2021 году',
            },
            {
                title: '986',
                description: 'розничных салонов',
            },
            {
                title: '32%',
                description: 'рост объема продаж 2020/2021',
            },
            {
                title: '20',
                description: 'стран — география присутствия бренда',
            },
        ],
    },
    asus: {
        summary: [
            {
                title: '>&nbsp;30&nbsp;<span>лет</span>',
                description: `ASUS создает устройства для&nbsp;рынка ПК –&nbsp;один из&nbsp;крупнейших производителей ноутбуков на&nbsp;мировом рынке`,
            },
            {
                title: '>&nbsp;14,5&nbsp;<span>тыс.</span>',
                description: 'сотрудников и&nbsp;62&nbsp;представительств по&nbsp;всему миру',
            },
            {
                title: '>&nbsp;1000',
                description: 'наград за&nbsp;дизайн и&nbsp;инновации на&nbsp;различных международных выставках',
            },
        ],
    },
    education: {
        summary: [
            {
                title: '537',
                description: 'крупных школ',
            },
            {
                title: '52',
                description: 'колледжа',
            },
            {
                title: '1&nbsp;520&nbsp;<span>млн</span>',
                description: 'учащихся',
            },
            {
                title: '+247&nbsp;<span>%</span>',
                description: `за 10&nbsp;лет увеличилось количество выпускников, набравших на&nbsp;ЕГЭ по&nbsp;трем предметам более 220 баллов`,
            },
        ],
    },
    fcongress: {
        summary: [
            {
                title: '21&nbsp;000',
                description: 'совокупная ежегодная аудитория мероприятий',
            },
            {
                title: '<span>></span>5&nbsp;000',
                description: 'ежегодная аудитория офлайн мероприятия',
            },
            {
                title: '20<span>+</span>',
                description: 'крупных мероприятий ежегодно',
            },
        ],
    },
    forbesteen: {
        summary: [
            {
                title: '100&nbsp;<span>+</span>',
                description: 'Школьников прошли наши программы',
            },
            {
                title: '30&nbsp;<span>+</span>',
                description: 'Стартапов',
            },
            {
                title: '500&nbsp;000',
                description: 'Руб.&nbsp;заработали наши выпускники на&nbsp;своих первых бизнесах',
            },
        ],
    },
    fransizy: {
        caption: 'О проекте',
    },
    generations: {
        summary: [
            {
                title: '15&nbsp;000&nbsp;<span>+</span>',
                description: 'стартапов в&nbsp;базе',
            },
            {
                title: '60&nbsp;<span>+</span>',
                description: 'компаний партнеров',
            },
            {
                title: '250&nbsp;<span>+</span>',
                description: 'партнерская сеть вузов и&nbsp;региональных технопарков',
            },
            {
                title: '100&nbsp;<span>+</span>',
                description: 'сделок и&nbsp;интеграций стартапов с&nbsp;корпорациями',
            },
        ],
    },
    ipquorum: {
        summary: [
            {
                title: '1500&nbsp;<span>+</span>',
                description: 'Участников',
            },
            {
                title: '30&nbsp;<span>+</span>',
                description: 'Стран',
            },
            {
                title: '100&nbsp;<span>+</span>',
                description: 'Спикеров',
            },
            {
                title: '90&nbsp;<span>+</span>',
                description: 'Планерных заседаний, дискуссий и&nbsp;тематических секций',
            },
        ],
    },
    lazurit: {
        summary: [
            {
                title: '500',
                description: 'салонов в 170 городах России',
            },
            {
                title: '28&nbsp;<span>млн</span>',
                description: 'посетителей интернет-магазина в 2022 г.',
            },
            {
                title: '50&nbsp;000',
                description: 'заказов в месяц',
            },
            {
                title: '80&nbsp;000&nbsp;<span>кв.&nbsp;м</span>',
                description: 'производственных ресурсов',
            },
        ],
    },
    loti: {
        summary: [
            {
                title: '1',
                description: 'туроператор, предлагающий туры с перелетом на бизнес-лайнере Lujo BlackJet',
            },
            {
                title: '4',
                description: 'страны для отдыха - Турция, Мальдивы, ОАЭ, Таиланд',
            },
            {
                title: '350&nbsp;<span>+</span>',
                description: 'отелей уровня 5* deluxe на прямых контрактах',
            },
            {
                title: '15 000&nbsp;<span>+</span>',
                description: 'партнеров турагентской розницы',
            },
        ],
    },
    'malyj-biznes-moskvy': {
        summary: [
            {
                title: '<span>></span>&nbsp;1&nbsp;<span>млн</span>',
                description: 'консультаций',
            },
            {
                title: '<span>~</span>&nbsp;540&nbsp;<span>тыс.</span> ',
                description: 'получателей образовательной поддержки',
            },
            {
                title: '<span>></span>&nbsp;35',
                description: 'онлайн-сервисов',
            },
        ],
    },
    mangazeya: {
        summary: [
            {
                title: '1000&nbsp;<span>+</span>',
                description: 'человек работает на&nbsp;предприятиях ГК&nbsp;«Мангазея»',
            },
            {
                title: '130&nbsp;<span>+</span>',
                description: 'тонн —&nbsp;запасы золота на&nbsp;месторождениях компании',
            },
            {
                title: '50&nbsp;000&nbsp;<span>+</span>',
                description: 'кв.&nbsp;м.&nbsp;жилья сдано в&nbsp;2018&nbsp;году «Мангазея&nbsp;Девелопментом»',
            },
            {
                title: '60&nbsp;000',
                description: 'гектаров земли под&nbsp;развитие аграрного направления на&nbsp;Дальнем Востоке',
            },
        ],
    },
    mosprom: {
        summary: [
            {
                title: 'в 183 <span>страны</span>',
                description: 'Экспортируется продукция столицы',
            },
            {
                title: '$39,86 <span>млрд</span>',
                description: 'Экспорт (ННЭ) Москвы в 2020 году',
            },
            {
                title: '31 <span>%</span>',
                description: 'Рост столичного экспорта по сравнению с 2019 годом',
            },
        ],
    },
    moseconomy: {
        summary: [
            {
                title: '561',
                description: 'предприятие столицы получит адресную поддержку с 2022 по 2024 год',
            },
            {
                title: '109',
                description: 'предприятий будет охвачено уже в 2022 году',
            },
        ],
    },
    mybusiness: {
        summary: [
            {
                title: '335&nbsp;000&nbsp;<span>+</span>',
                description: 'услуг получили предприниматели в&nbsp;центрах «Мой&nbsp;бизнес»',
            },
            {
                title: '155&nbsp;000&nbsp;<span>+</span>',
                description: 'предпринимателей посетили центры «Мой&nbsp;бизнес»',
            },
            {
                title: '8&nbsp;200&nbsp;<span>+</span>',
                description: 'мероприятий для&nbsp;предпринимателей прошли в&nbsp;центрах «Мой&nbsp;бизнес»',
            },
            {
                title: '48',
                description: 'центров «Мой&nbsp;бизнес» открыто в&nbsp;России',
            },
        ],
    },
    nationalproject: {
        summary: [
            {
                title: '>&nbsp;5,7&nbsp;<span>млн</span>',
                description: 'субъектов малого и среднего предпринимательства\n',
            },
            {
                title: '>&nbsp;25&nbsp;<span>млн</span>',
                description: 'численность занятых в сфере МСП, включая ИП',
            },
            {
                title: 'не&nbsp;менее&nbsp;766',
                description: 'ИТ-стартапов получат господдержку до 2024 года',
            },
            {
                title: '7&nbsp;<span>млрд&nbsp;руб</span>',
                description: 'потратят на цифровизацию МСП до 2024 года',
            },
            {
                title: '>&nbsp;$180&nbsp;<span>млрд</span>',
                description: 'превысит объем несырьевого неэнергетического экспорта в 2021 году',
            },
            {
                title: 'в&nbsp;200&nbsp;<span>+&nbsp;стран</span>',
                description: 'осуществляется экспорт промышленной и продовольственной продукции в 2021 году',
            },
        ],
    },
    ocs: {
        summary: [
            {
                title: '27&nbsp;<span>лет</span>',
                description: 'на&nbsp;ИТ-рынке',
            },
            {
                title: '2&nbsp;300',
                description: 'сотрудников',
            },
            {
                title: '26',
                description: 'представительств в&nbsp;России',
            },
            {
                title: '7&nbsp;200',
                description: 'дилеров',
            },
            {
                title: '450',
                description: 'линеек от&nbsp;ведущих мировых вендоров',
            },
        ],
    },
    open: {
        summary: [
            {
                title: '410',
                description: 'клиентских офисов в России',
            },
            {
                title: 'ТОП-5',
                description: 'на рынке автокредитования',
            },
            {
                title: 'ТОП-10',
                description: 'по активам в стране',
            },
            {
                title: '100%',
                description: 'доля Банка России в акциях «Открытия»',
            },
        ],
    },
    procterandgamble: {
        summary: [
            {
                title: '5&nbsp;<span>млрд</span>',
                description: 'потребителей по&nbsp;всему миру',
            },
            {
                title: '$1&nbsp;<span>млрд</span>',
                description: 'инвестирован в&nbsp;российские предприятия P&G',
            },
            {
                title: '60&nbsp;<span>%</span>',
                description: 'продукции, представленной на&nbsp;рынке, производится в&nbsp;России',
            },
            {
                title: '800',
                description: 'товаров P&G приобретается в&nbsp;России каждую минуту',
            },
            {
                title: '0&nbsp;<span>%</span',
                description: 'твердых производственных отходов P&G идет на&nbsp;полигон',
            },
        ],
    },
    psb: {
        summary: [
            {
                title: '3,7&nbsp;<span>трлн&nbsp;руб</span>',
                description: 'активы ПСБ',
            },
            {
                title: '>&nbsp;2,8&nbsp;<span>млн</span>',
                description: 'розничных клиентов',
            },
            {
                title: '>&nbsp;270&nbsp;<span>тыс.</span>',
                description: 'корпоративных клиентов',
            },
            {
                title: '17&nbsp;<span>тыс.</span>',
                description: 'сотрудников работают в ПСБ',
            },
        ],
    },
    pyaterochka: {
        summary: [
            {
                title: '20&nbsp;761',
                description: 'количество магазинов на&nbsp;30.09.2023&nbsp;г.',
            },
            {
                title: '69',
                description: 'число регионов присутствия',
            },
            {
                title: '1,8&nbsp;<span>трлн&nbsp;руб</span>',
                description: 'выручка с&nbsp;учетом экспресс-доставки за&nbsp;9&nbsp;мес. 2023&nbsp;г.',
            },
            {
                title: '15,6&nbsp;<span>%</span>',
                description: 'рост выручки с&nbsp;учетом доставки за&nbsp;9&nbsp;мес. 2023&nbsp;г.',
            },
        ],
    },
    rbs: {
        summary: [
            {
                title: '>&nbsp;80',
                description: 'сотрудников в&nbsp;компании',
            },
            {
                title: '95&nbsp;<span>%</span>',
                description: 'специалистов компании —&nbsp;выпускники МГУ, МГИМО, НИУ&nbsp;ВШЭ, МГЮА',
            },
            {
                title: '300&nbsp;<span>+</span>',
                description: `реализованных проектов для&nbsp;лидирующих российских и&nbsp;международных компаний в&nbsp;различных отраслях экономики`,
            },
            {
                title: '30&nbsp;<span>+</span>',
                description: 'обучающих тренингов для&nbsp;клиентов',
            },
        ],
    },
    'real-estate-and-ad': {
        caption: 'О проекте',
    },
    rosatom: {
        summary: [
            {
                title: '>350',
                description: 'предприятий',
            },
            {
                title: '290&nbsp;000',
                description: `<a href="//rosatom-career.ru/?utm_source=forbes&utm_medium=special&utm_campaign=cifra&utm_content=main_card" rel="noopener noreferer nofollow" target="_blank">сотрудников</a>`,
            },
            {
                title: 'с&nbsp;2018&nbsp;<span>года</span>',
                description: `реализует единую цифровую стратегию (ЕЦС), предполагающую многоплановую работу по ряду направлений`,
            },
            {
                title: '>70',
                description: `<a href="//rosatomcatalog.ru/?utm_source=forbes&utm_medium=special&utm_campaign=cifra&utm_content=main_card" rel="noopener noreferer nofollow" target="_blank">цифровых продуктов в портфеле</a>`,
            },
        ],
    },
    russpass: {
        summary: [
            {
                title: '>25 <span>млн</span>',
                description: 'Гостей приезжают в столицу за год <span>*</span>',
            },
            {
                title: '76 <span>%</span>',
                description: 'Туристов в Москве — это жители России <span>*</span>',
            },
            {
                title: '56 <span>%</span>',
                description: 'Турпотока в Москве — активные люди в возрасте от 25 до 44 лет <span>**</span>',
            },
            {
                title: '300 <span>+</span>',
                description: 'Направлений и туров на платформе RUSSPASS',
            },
        ],
        sup: ['Данные за 2019 год', 'Исследование июль, 2020 год'],
    },
    sap: {
        summary: [
            {
                title: '345&nbsp;000',
                description: 'клиентов более, чем в&nbsp;180 странах',
            },
            {
                title: '76&nbsp;<span>%</span>',
                description: 'бизнес-операций в&nbsp;мире проходят через системы SAP',
            },
            {
                title: '€22,06&nbsp;<span>млрд</span>',
                description: 'общий оборот в&nbsp;2016&nbsp;г.',
            },
            {
                title: '87&nbsp;<span>%</span>',
                description: 'из мирового списка Forbes —&nbsp;клиенты SAP',
            },
        ],
    },
    sber: {
        summary: [
            {
                title: '183&nbsp;<span>года</span>',
                description: 'Сбербанк',
            },
            {
                title: '110&nbsp;<span>млн</span>',
                description: 'клиентов – физических лиц',
            },
            {
                title: '3,3&nbsp;<span>млн</span>',
                description: 'клиентов – юридических лиц',
            },
        ],
    },
    'skola-upravlenia-skolkovo': {
        summary: [
            {
                title: '55&nbsp;000<span>+</span>',
                description: 'выпускников',
            },
            {
                title: '50',
                description: 'наград в области образования, предпринимательства, коммуникаций и цифровизации',
            },
            {
                title: '<span>></span>&nbsp;17&nbsp;<span>лет</span>',
                description: 'помогаем талантливым стать успешным',
            },
        ],
    },
    'stil-zizni': {
        caption: 'О проекте',
    },
    tinkoff: {
        summary: [
            {
                title: '10&nbsp;000&nbsp;<span>+</span>',
                description: 'Ценных бумаг на выбор',
            },
            {
                title: '27 / 7',
                description: 'Поддержка по инвестициям',
            },
            {
                title: '1',
                description: 'Коммиссия за все',
            },
            {
                title: '500&nbsp;<span>$&nbsp;/&nbsp;€</span>',
                description: 'Низкий вход для торговли еврооблигациями',
            },
        ],
    },
    tinkoffbusiness: {
        summary: [
            {
                title: '600&nbsp;000&nbsp;<span>+</span>',
                description: 'компаний и&nbsp;предпринимателей по&nbsp;всей России',
            },
            {
                title: '>&nbsp;83&nbsp;<span>млрд&nbsp;руб</span>',
                description: 'остаток средств МСБ на&nbsp;счетах',
            },
            {
                title: '50&nbsp;<span>+</span>',
                description: 'продуктовых решений для&nbsp;бизнеса',
            },
            {
                title: '6',
                description: 'лет работы экосистемы для&nbsp;бизнеса',
            },
        ],
    },
    'tinkoff-private': {
        summary: [
            {
                title: '№1',
                description: 'розничный онлайн-банк в мире <span>*</span>',
            },
            {
                title: '20&nbsp;<span>млн</span>',
                description: 'клиентов',
            },
            {
                title: '1,8&nbsp;<span>млн</span>',
                description: 'активных инвесторов',
            },
            {
                title: '10&nbsp;000',
                description: 'доступных финансовых инструментов',
            },
        ],
        sup: ['По версии международного журнала Global Finance в 2020 году'],
    },
    trivio: {
        summary: [
            {
                title: '<span>~</span>&nbsp;1000',
                description: 'компаний из разных сфер бизнеса пользуются сервисом прямо сейчас',
            },
            {
                title: '<span>></span>&nbsp;3000',
                description: 'услуг оформляется ежедневно через сервис Trivio',
            },
            {
                title: '<span>До</span>&nbsp;30&nbsp;<span>%</span>',
                description: 'возможная экономия бюджета компании',
            },
            {
                title: '10&nbsp;<span>раз</span>',
                description: 'во столько снижается объем трудозатрат при организации командировок с помощью онлайн-платформы',
            },
        ],
    },
    trust: {
        summary: [
            {
                title: '482&nbsp;<span>млрд&nbsp;руб</span>',
                description: 'цель «Траста» до 2024 года',
            },
            {
                title: '242&nbsp;<span>млрд&nbsp;руб</span>',
                description: 'возврат в ЦБ за 2019–2021 годы',
            },
            {
                title: '11',
                description: 'компаний под управлением',
            },
            {
                title: '30&nbsp;000',
                description: 'сотрудников',
            },
        ],
    },
    'twenty-ideas': {
        caption: 'О проекте',
        summary: [
            {
                title: '2&nbsp;019&nbsp;<span>трлн&nbsp;руб</span>',
                description: 'минимальная ежегодная прибыль госбюджета в случае реализации идей Дмитрия Давыдова',
            },
            {
                title: '1&nbsp;207',
                description: 'статей и видео, освещающих проект, опубликовано в российских СМИ',
            },
            {
                title: '2&nbsp;648',
                description: 'публикаций о проекте в социальных сетях',
            },
        ],
    },
    uralhim: {
        summary: [
            {
                title: '1',
                description: 'место в России по выпуску аммиачной селитры и ее производных',
            },
            {
                title: '1',
                description: 'место по поставке аммиачной селитры на внутренний рынок',
            },
            {
                title: '1',
                description: 'место в России по производству хлористого калия',
            },
            {
                title: '1',
                description: 'место по поставке хлористого калия на внутренний рынок',
            },
            {
                title: '6',
                description: 'производственных активов',
            },
            {
                title: '>&nbsp;100',
                description: 'наименований минеральных удобрений',
            },
            {
                title: '>&nbsp;31&nbsp;000 ',
                description: 'сотрудников',
            },
        ],
    },
    valartis: {
        summary: [
            {
                title: '6',
                description: 'Количество бизнес-центров',
            },
            {
                title: '>&nbsp;100&nbsp;000',
                description: 'кв.м. Общая арендуемая площадь',
            },
            {
                title: '174',
                description: 'Количество арендаторов',
            },
            {
                title: '87&nbsp;<span>%</span>',
                description: 'Процент заполняемости',
            },
        ],
    },
    vtb: {
        summary: [
            {
                title: '15,3 <span>трлн руб</span>',
                description: 'Активы группы ВТБ',
            },
            {
                title: '14 <span>млн</span>',
                description: 'Банковских клиентов в России',
            },
            {
                title: '82 000',
                description: 'Сотрудников работают в группе ВТБ',
            },
        ],
    },
    wildberries: {
        summary: [
            {
                title: '15&nbsp;<span style="color: #2d2d2d">млн</span>',
                description: 'заказов в сутки',
            },
            {
                title: '8&nbsp;<span style="color: #2d2d2d">стран</span>',
                description: 'присутствия',
            },
            {
                title: '2,5&nbsp;<span style="color: #2d2d2d">млн&nbsp;кв.&nbsp;м</span>',
                description: 'площадь логистических объектов',
            },
            {
                title: '>&nbsp;150&nbsp;000',
                description: 'рекламных поверхностей различных форматов с охватом более 85 млн человек ежемесячно',
            },
        ],
    },
    'sovcombank-wealth-management': {
        summary: [
            {
                title: '>20&nbsp;<span>регионов</span>',
                description: 'присутствие офисов в России',
            },
            {
                title: '>6000',
                description: 'клиентов',
            },
            {
                title: '57%',
                description: 'инвест-проникновение',
            },
        ],
    },
};
